import { color, radius, spacing } from '@gyym/ui'
import styled from 'styled-components'

export const CampaignDialogBodyBackground = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing(1)};
  text-align: center;
  justify-content: center;
  align-items: center;
  border-radius: ${radius('md')};
  background: ${color('gray.06')};
  padding: ${spacing(3)};
  width: 100%;
`
